import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class Img extends Component {
	/**
	 *
	 * @param {*} obj {obj.src, obj.alt}
	 * @param  {...any} args
	 * @returns
	 */
	render(obj, ...args) {
		return h._(
			h.img(
				{
					src: obj.src,
					alt: obj.alt,
				},
				...args
			)
		);
	}
}

ojs(Img);
